import { render, staticRenderFns } from "./RegionIcon.vue?vue&type=template&id=4d68a753"
import script from "./RegionIcon.vue?vue&type=script&lang=ts"
export * from "./RegionIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports